// Material Symbols glyph used for UI buttons (decorative; the button carries the aria-label)
export default function UiIcon({ name, className = '' }) {
  return (
    <span className={`material-symbols-outlined ui-icon${className ? ' ' + className : ''}`} aria-hidden="true">{name}</span>
  );
}
